import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 4h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.657 6.343h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.657 17.657h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.343 17.657h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.343 6.343h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SunDim";
const SunDim = memo(themed(Icon));
export {
  SunDim
};
//# sourceMappingURL=sun-dim.js.map
